import React, { memo } from 'react';

import { Box } from '~/eds/src/components/Box/Box';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { MarkedText } from '~/eds/src/components/MarkedText/MarkedText';
import { TruncateText } from '~/eds/src/components/Text/subcomponents/TruncateText';
import { useDrag } from '~/features/drag-and-drop/DragContext';

type Props = {
  id: string;
  label: string;
  search?: string;
};

const FilterItemComponent = ({ id, label, search }: Props) => {
  const { handleDragStart, handleDragEnd } = useDrag();
  return (
    <div
      draggable
      onDragStart={() => handleDragStart({ id })}
      onDragEnd={handleDragEnd}
    >
      <Layout
        p={4}
        borderRadius="m"
        h="header.height.s"
        align="center"
        bg="white"
        onClick={() => {}}
        justify="space-between"
        styles={styles.draggableContainer}
      >
        <TruncateText>
          <MarkedText search={search} text={label} />
        </TruncateText>
        <Box data-icon-container>
          <Icon icon="reorder" />
        </Box>
      </Layout>
    </div>
  );
};

export const FilterItem = memo(FilterItemComponent);

const styles = {
  draggableContainer: {
    userSelect: 'none',
    '& [data-icon-container]': {
      opacity: 0,
    },
    '&:hover [data-icon-container]': {
      opacity: 1,
    },
  },
};
